import * as React from 'react';
export const svbSvg = React.forwardRef(function svbSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M0 0h32v32H0z',
        fill: '#1ca0e1',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M24.22 20.614c-.641 0-1.247-.35-1.64-.72v-5c.482-.438 1.034-.719 1.73-.719 1.176 0 1.533.877 1.533 3.14 0 2.369-.392 3.299-1.623 3.299zm.75-7.947c1.675 0 3.03.965 3.03 4.544C28 21.053 26.663 22 24.755 22c-1.016 0-1.871-.526-2.424-1.123l-.25.895h-1.533V10.386l-1.07-.228V9h3.102v4.79c.553-.597 1.39-1.123 2.39-1.123zm-7.86 1.561-.98-.123v-1.21h3.423v1.228l-.82.14-2.603 7.509h-1.926l-2.602-7.526-.767-.123v-1.228h3.797v1.21l-.891.14 1.23 3.93c.232.737.339 1.351.464 2.053h.018a16.6 16.6 0 0 1 .48-2.07zm-9.58 2.105c1.569.421 2.674 1 2.674 2.965 0 1.807-1.32 2.702-3.351 2.702C5.64 22 4.66 21.72 4 21.35v-2.175h1.39l.286 1.369c.374.175.588.228 1.158.228 1.088 0 1.516-.421 1.516-1.228 0-.86-.481-1.176-1.747-1.509-1.515-.403-2.55-1.053-2.55-2.79 0-1.456 1.052-2.578 3.138-2.578 1.159 0 2.015.193 2.674.526v2.158H8.528l-.32-1.299c-.268-.122-.571-.175-.999-.175-.891 0-1.39.386-1.39 1.088 0 .72.427 1.035 1.71 1.368z',
        fill: '#fff',
      }),
    ),
  );
});
svbSvg.defaultProps = {
  height: '32',
  viewBox: '0 0 32 32',
  width: '32',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var svb = {
  category: 'brand',
  colorable: false,
  name: 'svb',
  svg: svbSvg,
};
